export default __webpack_public_path__ + "static/media/background.c367868f.jpg";